import { render, staticRenderFns } from "./MiniProgramModal.vue?vue&type=template&id=37c3f0a7&scoped=true"
import script from "./MiniProgramModal.vue?vue&type=script&lang=js"
export * from "./MiniProgramModal.vue?vue&type=script&lang=js"
import style0 from "./MiniProgramModal.vue?vue&type=style&index=0&id=37c3f0a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c3f0a7",
  null
  
)

export default component.exports